const STORAGE_KEY = "gaosiweb-brand-notice-2026";
const STYLE_ID = "gaosiweb-brand-notice-style";

const getTodayKey = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const date = String(today.getDate()).padStart(2, "0");
  return `${today.getFullYear()}-${month}-${date}`;
};

const styles = `
.brand-notice{position:fixed;z-index:2000;inset:0;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(20,19,27,.52)}
.brand-notice__panel{position:relative;width:640px;max-width:100%;max-height:calc(100vh - 48px);overflow:auto;padding:40px 44px 38px;border-radius:20px;background:#fff;box-shadow:0 24px 60px rgba(32,31,40,.22);animation:brand-notice-in .32s cubic-bezier(.2,.8,.3,1)}
.brand-notice__close{position:absolute;top:16px;right:16px;width:32px;height:32px;border:0;border-radius:50%;color:#8a8894;background:transparent;font-size:24px;line-height:1;cursor:pointer}
.brand-notice__close:hover{color:#22212b;background:#f2f1f5}.brand-notice__header{margin-bottom:22px;text-align:center}.brand-notice__header h2{margin:0;color:#22212b;font-size:22px;line-height:1.4}.brand-notice__body{color:#4a4952;font-size:15px;line-height:1.95}.brand-notice__body p{margin:0 0 12px;text-align:justify}.brand-notice__body .brand-notice__indent{text-indent:2em}.brand-notice__sign{margin-top:18px;color:#22212b;line-height:1.9;text-align:right}.brand-notice__sign span{display:block}
@keyframes brand-notice-in{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}
@media (max-width:820px){.brand-notice{padding:16px}.brand-notice__panel{max-height:calc(100vh - 32px);padding:28px 20px 24px;border-radius:16px}.brand-notice__close{top:12px;right:12px}.brand-notice__header{padding:0 26px}.brand-notice__header h2{font-size:18px}.brand-notice__body{font-size:14px}}
`;

const template = `
  <div v-if="visible" class="brand-notice" role="dialog" aria-modal="true" aria-labelledby="brand-notice-title">
    <div class="brand-notice__panel">
      <button class="brand-notice__close" type="button" aria-label="关闭公告" @click="close">×</button>
      <div class="brand-notice__header"><h2 id="brand-notice-title">高思教育旗下学科培训品牌焕新为「好爱学」</h2></div>
      <div class="brand-notice__body">
        <p>尊敬的家长、同学们：</p>
        <p class="brand-notice__indent">自 2009 年创办以来，高思教育始终专注于教研与教学，以专业的课程体系和持续迭代的技术能力，陪伴万千孩子稳步成长。为持续提升教学品质与学习体验，高思教育旗下学科培训品牌正式焕新为「好爱学」，专注夯实学科基础、培养综合学习能力。目前已有课程体系、师资团队、教学安排与学习服务均保持不变；已报名课程、已享权益及家校沟通机制不受本次品牌焕新影响，教学服务将正常开展。</p>
        <p class="brand-notice__indent">感谢各位家长、同学一直以来的信任与支持。未来，好爱学将延续高思教育一贯的教研基因与教学品质，围绕孩子的学习过程与成长需求，提供更加标准化、专业化的教学与服务，陪伴孩子认真学习、持续成长。</p>
        <div class="brand-notice__sign"><span>高思教育</span><span>2026 年 9 月</span></div>
      </div>
    </div>
  </div>
`;

export default {
  name: "BrandNotice",
  template,
  data() {
    return { visible: false };
  },
  mounted() {
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = styles;
      document.head.appendChild(style);
    }
    const todayKey = getTodayKey();
    this.visible = localStorage.getItem(STORAGE_KEY) !== todayKey;
    if (this.visible) {
      localStorage.setItem(STORAGE_KEY, todayKey);
    }
  },
  methods: {
    close() {
      localStorage.setItem(STORAGE_KEY, getTodayKey());
      this.visible = false;
    }
  }
};



//////////////////
// WEBPACK FOOTER
// /resource/code/pmn3myn9-dev_web_old_1.5.427/packages/gaosiweb-common/components/brand-notice.js
// module id = null
// module chunks = 